import React, { useState, useEffect } from "react";
import { Select, Tooltip, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCustomizedDate } from "../../../redux/constants";
import InfoIcon from "../../../assets/Info_Icon.svg";
import moment from "moment";
import {
  setDateValue,
  setTimeValue,
  setRelativeCount,
} from "../../../redux/actions/DateTime";
import isEqual from "react-fast-compare";
const Relative = ({
  datePicker,
  type,
  split,
  setDatepicker,
  keepAsRelative,
  setKeepAsRelative,
}) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const hours = [1, 3, 5, 6, 12, 24];
  const days = [1, 3, 5, 10, 20, 30];
  const weeks = [1, 2, 3, 4, 5, 6];
  const months = [1, 3, 6, 12, 18, 24];
  const years = [1, 2, 3, 4, 5, 6];
  const short = ["MTD", "YTD"];
  const custom = ["Days", "Weeks", "Months", "Years"];
  const [customOption, setcustomOption] = useState("Days");
  const [inputNumber, setinputNumber] = useState();
  const relativeCount = useSelector((state) => state.DateTime.relativeCount);
  const dateValue = useSelector((state) => state.DateTime.dateValue);
  const timeValue = useSelector((state) => state.DateTime.timeValue);
  const authParams = useSelector((state) => state.Authentication.authParams);

  //function to input custom number
  const onInput = (e) => {
    const re = /^[0-9\b]+$/;
    let value = e.target.value;

    // if value is not blank, then test the regex
    if (e.target.value === "" || re.test(e.target.value)) {
      if (value == 0) {
        value = "";
        setinputNumber(value);
      } else {
        if (customOption === "Years" && e.target.value > 6) {
          value = 0;
        }
        if (customOption === "Months" && e.target.value > 72) {
          value = 0;
        }
        setinputNumber(value);
        let obj = getCustomizedDate(value, customOption, true, type);

        dispatch(setDateValue(dateValue, obj?.date, type));
        dispatch(setTimeValue(timeValue, obj?.time, type));
        dispatch(setRelativeCount(null));
      }
    }
  };
  //function to select custom options
  const OnCustomOptionChange = (value) => {
    setDatepicker(true);
    dispatch(setRelativeCount(null));
    setcustomOption(value);
    setinputNumber("");
  };
  //function to get relative date from the grid
  const getRelativeDate = (value, type1) => {
    // Reset keepAsRelative checkbox when selecting non-MTD/YTD options
    if (type1 !== "short" || (value !== "MTD" && value !== "YTD")) {
      setKeepAsRelative(false);
    }
    if (type === "split") {
      let currentObj = dateValue[type]?.data; //set dateValue in currentObj
      let date = [
        moment().subtract(value, type1).format("DD MMM  YYYY"),
        moment().subtract(0, "days").format("DD MMM  YYYY"),
      ]; //format the dates and put it in array
      let obj = getCustomizedDate(value, type1, false, type);
      obj.date.relative = { value: value, type: type1 };
      let finalObj;
      let finalTimeObj;
      if (split === "one") {
        finalObj = {
          one: date,
          two: currentObj?.two,
          three: currentObj?.three,
        };
        finalTimeObj = {
          one: obj?.time,
          two: timeValue?.split?.data?.two,
          three: timeValue?.split?.data?.three,
        };
      } else if (split === "two") {
        finalObj = {
          one: currentObj?.one,
          two: date,
          three: currentObj?.three,
        };
        finalTimeObj = {
          one: timeValue?.split?.data?.one,
          two: obj?.time,
          three: timeValue?.split?.data?.three,
        };
      } else if (split === "three") {
        finalObj = {
          one: currentObj?.one,
          two: currentObj?.two,
          three: date,
        };
        finalTimeObj = {
          one: timeValue?.split?.data?.one,
          two: timeValue?.split?.data?.two,
          three: obj?.time,
        };
      }
      date && dispatch(setDateValue(dateValue, finalObj, type));
      dispatch(setTimeValue(timeValue, finalTimeObj, type));
      dispatch(setRelativeCount({ value: value, type: type1 }));
    } else {
      let obj = getCustomizedDate(value, type1, false, type);
      let addOneDay =
        type1 === "short"
          ? moment(obj?.date[0]).format("DD MMM  YYYY")
          : type1 === "Hours"
          ? moment(obj?.date[0]).format("DD MMM  YYYY")
          : moment(obj?.date[0]).add(1, "days").format("DD MMM  YYYY");
      obj.date[0] = addOneDay;

      obj.date.relative = { value: value, type: type1 };
      dispatch(setDateValue(dateValue, obj?.date, type));
      dispatch(setTimeValue(timeValue, obj?.time, type));
      dispatch(setRelativeCount({ value: value, type: type1 }));
    }
  };
  //commented to prevent setting checkbox false by default, it will be set in parent by default
  // useEffect(() => {
  //   // setinputNumber("");
  //   setKeepAsRelative(false); // Reset checkbox when datePicker changes
  // }, [datePicker, dispatch]);

  // Helper function to check if MTD or YTD is currently selected
  const isMTDOrYTDSelected = () => {
    return (
      dateValue?.[type]?.data?.["relative"]?.type === "short" &&
      (dateValue?.[type]?.data?.["relative"]?.value === "MTD" ||
        dateValue?.[type]?.data?.["relative"]?.value === "YTD")
    );
  };

  // Handle checkbox change
  const handleKeepAsRelativeChange = (e) => {
    setKeepAsRelative(e.target.checked);
    // You can add additional logic here to handle the checkbox state
    // For example, store it in Redux or pass it to parent component
  };

  return (
    <div
      className={`table-responsive relative_table p-2 pt-15 pb-15 `}
      // ${
      //   authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      // }
      style={{ minHeight: "31rem" }}
    >
      <table class="table table-borderless mb-0">
        <tbody>
          <tr>
            <td>
              <b className="text_regular font-weight500">Hours</b>
            </td>
            {hours?.map((el, i) => {
              return (
                <td key={i}>
                  <span
                    className={`text_regular pt-1 pb-1 pl-15 pr-15 border border-color cursor-pointer ${
                      el === dateValue?.[type]?.data?.["relative"]?.value &&
                      dateValue?.[type]?.data?.["relative"]?.type === "Hours" &&
                      "active"
                    } `}
                    onClick={() => getRelativeDate(el, "Hours")}
                  >
                    {el}
                  </span>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <b className="text_regular font-weight500">Days</b>
            </td>
            {days?.map((el, i) => {
              return (
                <td key={i}>
                  <span
                    onClick={() => getRelativeDate(el, "Days")}
                    className={`text_regular pt-1 pb-1 pl-15 pr-15 border border-color cursor-pointer ${
                      el === dateValue?.[type]?.data?.["relative"]?.value &&
                      dateValue?.[type]?.data?.["relative"]?.type === "Days" &&
                      "active"
                    } `}
                  >
                    {el}
                  </span>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <b className="text_regular font-weight500">Weeks</b>
            </td>
            {weeks?.map((el, i) => {
              return (
                <td key={i}>
                  <span
                    onClick={() => getRelativeDate(el, "Weeks")}
                    className={`text_regular pt-1 pb-1 pl-15 pr-15 border border-color cursor-pointer ${
                      el === dateValue?.[type]?.data?.["relative"]?.value &&
                      dateValue?.[type]?.data?.["relative"]?.type === "Weeks" &&
                      "active"
                    } `}
                  >
                    {el}
                  </span>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <b className="text_regular font-weight500">Months</b>
            </td>
            {months?.map((el, i) => {
              return (
                <td key={i}>
                  <span
                    onClick={() => getRelativeDate(el, "Months")}
                    className={`text_regular pt-1 pb-1 pl-15 pr-15 border border-color cursor-pointer ${
                      el === dateValue?.[type]?.data?.["relative"]?.value &&
                      dateValue?.[type]?.data?.["relative"]?.type ===
                        "Months" &&
                      "active"
                    } `}
                  >
                    {el}
                  </span>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <b className="text_regular font-weight500">Years</b>
            </td>
            {years?.map((el, i) => {
              return (
                <td key={i}>
                  <span
                    onClick={() => getRelativeDate(el, "Years")}
                    className={`text_regular pt-1 pb-1 pl-15 pr-15 border border-color cursor-pointer ${
                      el === dateValue?.[type]?.data?.["relative"]?.value &&
                      dateValue?.[type]?.data?.["relative"]?.type === "Years" &&
                      "active"
                    } `}
                  >
                    {el}
                  </span>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <b className="text_regular font-weight500">Period</b>
            </td>
            {short?.map((el, i) => {
              return (
                <td key={i}>
                  <Tooltip
                    title={
                      el === "MTD"
                        ? "Month to date"
                        : el === "YTD"
                        ? "Year to date"
                        : ""
                    }
                  >
                    <span
                      // style={{ fontSize: "12px" }}
                      onClick={() => getRelativeDate(el, "short")}
                      className={`text_regular pt-1 pb-1 border border-color cursor-pointer ${
                        el === dateValue?.[type]?.data?.["relative"]?.value &&
                        dateValue?.[type]?.data?.["relative"]?.type ===
                          "short" &&
                        "active"
                      } `}
                    >
                      {el}
                    </span>
                  </Tooltip>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      <div className="d-flex justify-content-between mt-2 mb-2">
        <div className="form-group d-flex align-items-center ml-2 mb-0">
          <label className="mr-15 mb-0 text_regular font-weight500">
            Custom
          </label>
          <Select
            style={{ width: "10rem", height: "auto" }}
            onChange={(value) => OnCustomOptionChange(value)}
            value={customOption}
            className="font-size14 mb-0 customDate_select border-radius-4"
            placeholder="Select Custom Date"
            dropdownClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
          >
            {custom?.map((el, i) => {
              return (
                <Option key={i} value={el}>
                  {el}
                </Option>
              );
            })}
          </Select>
        </div>
        <div className="form-group d-flex align-items-center mb-0 mr-2">
          <label className="mr-2 mb-0 text_regular font-weight500">
            {customOption}
          </label>
          <input
            className="form-control text_regular border-color border-radius-4"
            type="text"
            style={{ width: "13rem", height: "4rem" }}
            maxLength={
              customOption === "Days"
                ? 4
                : customOption === "Months"
                ? 2
                : customOption === "Weeks"
                ? 2
                : 1
            }
            placeholder="Enter here"
            onChange={(e) => onInput(e)}
            value={inputNumber}
          />
        </div>
      </div>{" "}
      {/* Keep as relative duration checkbox */}
      {[
        "global_dashboard",
        "advance_settings",
        "widgetMaker",
        "dashboard_widget",
        "dashboard_section",
        "template_section",
        "template_widget",
      ]?.includes(type) && (
        <div className="ml-2 d-flex justify-content-between mt-3 mb-2">
          <div className="d-flex align-items-center">
            <Checkbox
              checked={isMTDOrYTDSelected() && keepAsRelative}
              onChange={handleKeepAsRelativeChange}
              // disabled={!isMTDOrYTDSelected()}
              className={`text_regular ${
                !isMTDOrYTDSelected() ? "disable" : ""
              }`}
            >
              Keep as relative duration
            </Checkbox>
            <Tooltip
              title={
                !isMTDOrYTDSelected()
                  ? "Works only with MTD & YTD"
                  : "To always load this on relative duration selection, works only with MTD & YTD"
              }
              placement="top"
            >
              <img
                src={InfoIcon}
                alt="Info Icon"
                className="ml-1 cursor-pointer"
                style={{ opacity: !isMTDOrYTDSelected() ? 0.5 : 1 }}
              />
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(Relative, isEqual);
